// extracted by css-extract-rspack-plugin
export default {"body":"SavedViewDialog-module__body__k1Fue","content":"SavedViewDialog-module__content__Mr6ed"};